import { render } from "./BlogStandardPage.vue?vue&type=template&id=dc97f1bc&ts=true"
import script from "./BlogStandardPage.vue?vue&type=script&lang=ts"
export * from "./BlogStandardPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__